import React from "react";
import renderReliability from "@/components/tippy/Tippy";
import { useTranslation } from "react-i18next";


const Reliability = ({ reliability }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      {/* Reliability type 'Modelled'  */}
      {/* {(reliability == 'Modelled' && model.isEu != true) && <div>
    <div className="reliability-tag-tool-tip" data-tippy-content="${pageProperties.reliabilityDefinitionSalesModelled}">
      <span className="reliability-tag">
          <span className="reliability-tag-icon"></span>
          <span className="reliability-tag-label">${reliability}</span>
      </span>
    </div>
  </div>} */}

      {/* Reliability type 'Estimated' */}
      {/* {(reliability == 'Estimated' && model.isEu != true) && <div>
    <div className="reliability-tag-tool-tip" data-tippy-content="${pageProperties.reliabilityDefinitionSalesEstimated}">
      <span className="reliability-tag">
          <span className="reliability-tag-icon"></span>
          <span className="reliability-tag-label">${reliability}</span>
      </span>
    </div>
  </div>} */}

      {/* Reliability type 'Actual'  */}
      {/* {(reliability == 'Actual' && model.isEu != true) &&<div>
    <div className="reliability-tag-tool-tip" data-tippy-content="${pageProperties.reliabilityDefinitionSalesActual}">
      <span className="reliability-tag">
          <span className="reliability-tag-icon"></span>
          <span className="reliability-tag-label">${reliability}</span>
      </span>
    </div>
  </div>} */}

      <div className="display-inline reliability-tag-tool-tip">
        {renderReliability(t(`companyProfile.financial.reliabilityDefinitionSales${reliability}`), t(`companyProfile.financial.${reliability}`))}
      </div>
    </>);
}
export default Reliability;
